import styled from 'styled-components';

export const TextArea = styled.textarea<{ hasError?: boolean; minHeight?: number }>`
  width: 100%;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '120px')};
  padding: 8px;
  border: 1px solid
    ${({ theme, hasError }) => (hasError ? theme.colors.red800 : theme.colors.neutral100)};
  border-radius: 4px;
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.2s;
  resize: vertical;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;

  &:focus {
    outline: none;
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.red800 : theme.colors.primary600};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral500};
  }
`;

export const CharacterCount = styled.div`
  margin-top: 0.25rem;
  text-align: right;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.neutral500};
`;

export const ErrorMessage = styled.span`
  display: flex;
  align-items: end;
  gap: 0.3rem;
  color: ${({ theme }) => theme.colors.red800};
  font-size: 12px;
  margin-top: 0.5rem;
`;
